import { render, staticRenderFns } from "./TenderingSettings.vue?vue&type=template&id=60d2aa7c&"
import script from "./TenderingSettings.vue?vue&type=script&lang=js&"
export * from "./TenderingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports